import React, { useState } from 'react';
import styles from './DetailSectionPublic.module.css';
import {
    OptimizedMotion,
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import IconPricingFeature from '../../../shared/ui/icons/IconPricingFeature';
import IconPricingRocket from '../../../shared/ui/icons/IconPricingRocket';

const DetailSectionPublic: React.FC = () => {
    const [isYearly, setIsYearly] = useState(false);

    const plans = [
        {
            id: 'essential',
            name: 'Essential',
            description: 'For small brands who want to look consistent.',
            note: 'Free 3-day trial',
            monthly: '$19',
            yearly: '$190',
            currency: '/ month',
            isPopular: false,
            buttonText: 'Coming Soon',
            features: [
                '50 AI-enhanced image edits per month',
                'Background removal & lighting correction',
                'One-click brand color & font sync',
                'Save and reuse brand templates',
                'Schedule up to 15 posts per month',
                'Preview analytics (reach & engagement)',
            ],
        },
        {
            id: 'pro',
            name: 'Pro',
            description: 'For brands that want speed, consistency, and results.',
            note: 'Most Popular — Built to Scale',
            monthly: '$49',
            yearly: '$490',
            currency: '/ month',
            isPopular: true,
            buttonText: 'Coming Soon',
            features: [
                'Unlimited AI-enhanced image edits',
                'Smart Calendar with auto-post at best times',
                'Batch edit up to 100 images',
                'Instant product showcase builder',
                'Brand analytics dashboard (tone, performance, consistency)',
                'Team collaboration (up to 3 seats)',
                'Priority support',
            ],
            footerNote: 'Save 20+ hours a week and never worry about “what to post” again.',
        },
        {
            id: 'enterprise',
            name: 'Enterprise',
            description: 'For agencies and large brands managing multiple stores or clients.',
            note: 'Let’s talk',
            monthly: '',
            yearly: '',
            currency: '',
            isPopular: false,
            buttonText: 'Coming Soon',
            features: [
                'Unlimited brands & team seats',
                'API + integration access',
                'Dedicated account manager',
                'Custom automations & workflows',
                'Onboarding & team training',
            ],
        },
    ];

    return (
        <div className={styles.container}>
            <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                Get <span style={{ color: '#7A3EFF' }}>SimpleeCreate</span>
            </OptimizedMotionH1>

            <div className={styles.toggleWrapper}>
                <div className={styles.toggle}>
                    <button
                        className={!isYearly ? styles.activeToggle : ''}
                        onClick={() => setIsYearly(false)}
                    >
                        Pay Monthly
                    </button>
                    <button
                        className={isYearly ? styles.activeToggle : ''}
                        onClick={() => setIsYearly(true)}
                    >
                        Pay Yearly (save 40%)
                    </button>
                </div>
            </div>

            <div className={styles.pricingContainer}>
                {plans.map((plan, index) => (
                    <OptimizedMotion
                        key={plan.id}
                        className={[styles.card, plan.isPopular ? styles.cardFeatured : ''].join(
                            ' ',
                        )}
                        type="slide-up"
                        delay={0.2 + index * 0.15}
                        duration={0.4}
                    >
                        <div className={styles.iconRow}>
                            <div>
                                <p className={styles.planLabel}>{plan.name}</p>
                                <h3 className={styles.planTitle}>{plan.description}</h3>
                            </div>
                        </div>

                        {plan.note && <div className={styles.freeTrial}>{plan.note}</div>}

                        {plan.monthly && (
                            <div className={styles.priceRow}>
                                <span className={styles.priceValue}>
                                    {isYearly ? plan.yearly : plan.monthly}
                                </span>
                                <span className={styles.priceUnit}>{plan.currency}</span>
                            </div>
                        )}

                        <button className={plan.isPopular ? styles.btnPrimary : styles.btnGhost}>
                            {plan.buttonText}
                        </button>

                        <ul className={styles.featureList}>
                            {plan.features.map((feature, i) => (
                                <li key={i} className={styles.featureItem}>
                                    <span aria-hidden="true">
                                        <IconPricingFeature />
                                    </span>
                                    {feature}
                                </li>
                            ))}
                        </ul>

                        {plan.footerNote && (
                            <div className={styles.priceNote}>{plan.footerNote}</div>
                        )}
                    </OptimizedMotion>
                ))}
            </div>
        </div>
    );
};

export default DetailSectionPublic;
